import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ShowButton,
} from "react-admin";

const CameraList = ({ orgId, filter }) => {
  return (
    <List title="" basePath={"/cameras"} resource="cameras" filter={filter}>
      <Datagrid>
        <TextField source="name" />
        <TextField label="Camera Type" source="camera_type" />
        <TextField source="description" />
        <TextField source="camera_id" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default CameraList;